export const generatePageNumbers = (currentPage, totalPages, delta = 2) => {
  const pages = [];

  if (totalPages <= 6) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
  } else {
    pages.push(1);

    if (currentPage > delta + 2) pages.push("...");

    for (
      let i = Math.max(2, currentPage - delta);
      i <= Math.min(totalPages - 1, currentPage + delta);
      i++
    ) {
      pages.push(i);
    }

    if (currentPage < totalPages - (delta + 1)) pages.push("...");
    pages.push(totalPages);
  }

  return pages;
};
